import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { CAPTCHA_SITE_KEY, QUIZ_CAPTCHA_ACTIVE } from '../constants/config';
import { Outlet } from 'react-router-dom';
import QuizAuthGuard from './QuizAuthGuard';

const QuizLayout = () => {
  const quiz = (
    <QuizAuthGuard text="Prijavi se kako bi učestvovao u kvizu">
      <Outlet />
    </QuizAuthGuard>
  );

  if (!QUIZ_CAPTCHA_ACTIVE) {
    return quiz;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_SITE_KEY} language="sr">
      {quiz}
    </GoogleReCaptchaProvider>
  );
};

export default QuizLayout;
